import { BrowserOptions, browserSessionIntegration } from '@sentry/angular';

const piiDenylist = ['forwarded', '-ip', 'remote-', 'via', '-user'];

// Sentry 11 collects more by default than Sentry 10 (user IP address, cookies, unscrubbed headers, bodies,
// ...), attaches synthetic stack traces and counts one session per page load. These options keep the
// Sentry 10 behaviour: https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md
export const SENTRY_V10_DEFAULTS: Pick<BrowserOptions, 'attachStacktrace' | 'dataCollection' | 'integrations'> = {
  attachStacktrace: false,
  dataCollection: {
    cookies: false,
    databaseQueryData: false,
    genAI: { inputs: false, outputs: false },
    graphQL: { document: false, variables: false },
    httpBodies: [],
    httpHeaders: {
      request: { deny: piiDenylist },
      response: { deny: piiDenylist },
    },
    queues: false,
    urlQueryParams: { deny: piiDenylist },
    userInfo: false,
  },
  integrations: [browserSessionIntegration({ lifecycle: 'route' })],
};
